import { createFileRoute } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, FeatureFlag, TextKey } from '@mews-commander/enums';
import { GuideLinkButton, PageLayout, useBreadcrumbs } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';
import { Container } from '@optimus-web/core';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Finance/Cashier/_layout/PastShift/$shiftId')(
    {
        beforeLoad: ({ context: { checkFeatureFlag } }) => {
            checkFeatureFlag(FeatureFlag.cashierShiftPagesMigration);
        },
        component: () => <PageComponent />,
        loader: ({ params }) => ({
            title: () => `Cashier Shift Detail: ${params.shiftId}`,
        }),
        staticData: {
            owner: MewsTeam.Billing,
            type: RouteType.Frontend,
            title: TextKey.Ledgers,
        },
    }
);

const PageComponent = () => {
    const breadcrumbs = useBreadcrumbs();

    const actions = <GuideLinkButton size="small" guideLink={createGuideLink(ArticlePath.CreateDeleteCashier)} />;

    return (
        <PageLayout actions={actions} breadcrumbs={breadcrumbs}>
            <Container padding={['200', '400']}>Past shift DETAIL</Container>
        </PageLayout>
    );
};
